var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin",attrs:{"id":"app_content"}},[_c('h2',{staticClass:"mt-0 uc"},[_vm._v("ciao "),_c('strong',[_vm._v(_vm._s(_vm.user.name))]),_vm._v(", cosa devi fare oggi?")])])}
var staticRenderFns = []

export { render, staticRenderFns }